import { Tags } from "@portal/BaseComponents/Tag/AntTag";
import { styled } from "@stitches/react";


export const StyledUploadedFiles = styled(Tags, {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  maxWidth: "220px",
  gap: "var(--space-8)",
  padding: "var(--space-8) var(--space-12)",
  background: "var(--gray-2)",
  border: "1px solid var(--gray-4)",
  margin: 0,

  "&.ant-tag-hidden": {
    display: "none",
  },
  "&.ant-tag-close-icon": {
    margin: 0,
  },
});
